export default "__VITE_PUBLIC_ASSET__bfe8a241__"